// Integración Google Analytics 4 (gtag.js) sin dependencias externas.
// Se activa por ambiente: solo mide si VUE_APP_GA4_ID está seteada.
// Sin la var, initAnalytics() y trackPageView() son no-ops (no se carga gtag.js).

const GA4_ID = process.env.VUE_APP_GA4_ID;

/**
 * Inyecta el script gtag.js y hace el config inicial.
 * Llamar una sola vez, antes de montar la app.
 * Idempotente: si window.gtag ya existe, corta antes de insertar un 2do script.
 * send_page_view: false → el page_view de carga lo emite el router.afterEach,
 * evitando el doble conteo con el evento automático de gtag('config').
 */
export function initAnalytics() {
  if (!GA4_ID || window.gtag) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { send_page_view: false });
}

/**
 * Emite un page_view manual para la navegación SPA (history mode).
 * @param {import('vue-router').RouteLocationNormalized} to - ruta destino
 */
export function trackPageView(to) {
  if (!GA4_ID || !window.gtag) return;

  window.gtag("event", "page_view", {
    page_path: to.fullPath,
    page_location: window.location.href,
    page_title: document.title,
  });
}
